import { useState } from 'react';
import { FiArrowRight, FiCheck } from 'react-icons/fi';
import Footer from '../../components/Footer';
import { subscribe } from '../../api/subscriberApi';

export default function SecurityQuote() {
  const [form, setForm] = useState({ name: '', email: '', organization: '', frameworks: '', details: '' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    const notes = [
      form.organization && `Organization: ${form.organization}`,
      form.frameworks && `Frameworks: ${form.frameworks}`,
      form.details,
    ].filter(Boolean).join('\n');
    const res = await subscribe({
      email: form.email,
      name: form.name,
      source: 'security-quote',
      group: 'security-quote',
      notes,
    });
    if (res && res.ok === false) {
      setError('We could not save that. Email consulting@vectorlabsnc.com and we will reply.');
      return;
    }
    setSent(true);
  };

  return (
    <div className="security-page">
      <section className="security-hero">
        <p className="work-kicker">Security Engineering Workforce</p>
        <h1>Request a quote for security and compliance work.</h1>
        <p>
          Vector Labs has a growing team of cybersecurity professionals. Engagements cover security and compliance frameworks, including the SOC 2 work we built ComplianceOS around: production access, encryption in transit and at rest, and how long a vulnerability stays open.
        </p>
      </section>

      <section className="security-form-wrap">
        {sent ? (
          <p className="security-sent"><FiCheck /> Quote request received. We will reply to {form.email}.</p>
        ) : (
          <form className="security-form" onSubmit={submit}>
            <label>
              Name
              <input required value={form.name} onChange={set('name')} autoComplete="name" />
            </label>
            <label>
              Work email
              <input required type="email" value={form.email} onChange={set('email')} autoComplete="email" />
            </label>
            <label>
              Organization
              <input required value={form.organization} onChange={set('organization')} />
            </label>
            <label>
              Frameworks
              <input value={form.frameworks} onChange={set('frameworks')} placeholder="SOC 2, or the framework the customer is asking for" />
            </label>
            <label>
              What do you need quoted?
              <textarea required rows={5} value={form.details} onChange={set('details')} placeholder="Scope, deadline, and whether you need a team or a named lead." />
            </label>
            {error && <p className="security-error">{error}</p>}
            <button type="submit">Request a quote <FiArrowRight /></button>
          </form>
        )}
      </section>
      <Footer />
    </div>
  );
}
